import { render, staticRenderFns } from "./ChbPortChargesFormTableItem.vue?vue&type=template&id=7bd623d6&scoped=true"
import script from "./ChbPortChargesFormTableItem.vue?vue&type=script&lang=js"
export * from "./ChbPortChargesFormTableItem.vue?vue&type=script&lang=js"
import style0 from "./ChbPortChargesFormTableItem.vue?vue&type=style&index=0&id=7bd623d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd623d6",
  null
  
)

export default component.exports